import React, { useEffect, useState } from 'react'
import CardSucursal from './CardSucursal'
import MsgUtils from '../Tools/MsgUtils';
import Modal from 'react-bootstrap/Modal';
const server = process.env.REACT_APP_SERVER;
const mapeo = [
    { "id": 10, "abr": "CAJ", "rol": "CAJERA" },
    { "id": 101, "abr": "CAJ", "rol": "CAJERA" },
    { "id": 100, "abr": "CAJ", "rol": "CAJERA" },
    { "id": 8, "abr": "PRD", "rol": "PRODUCCION" },
    { "id": 9, "abr": "PRD", "rol": "PRODUCCION" },
    { "id": 102, "abr": "PRD", "rol": "PRODUCCION" },
    { "id": 11, "abr": "DSP", "rol": "DESPACHO" },
    { "id": 99, "abr": "CEN", "rol": "TELEFONISTA" },
    { "id": 12, "abr": "LIM", "rol": "LIMPIEZA" },
    { "id": 103, "abr": "LIM", "rol": "LIMPIEZA" },
    { "id": 7, "abr": "SUP", "rol": "SUPERVISOR" },
    { "id": 19, "abr": "SUP", "rol": "SUPERVISOR JR" },
    { "id": 220, "abr": "SUP", "rol": "POS. SUPERVISOR JR" },
    { "id": 50, "abr": "GUA", "rol": "GUARDIA" },
    { "id": 104, "abr": "GUA", "rol": "GUARDIA" },
]
const rolesUnicos = [
    { "abr": "CAJ", "rol": "CAJERA" },
    { "abr": "PRD", "rol": "PRODUCCION" },
    { "abr": "DSP", "rol": "DESPACHO" },
    { "abr": "CEN", "rol": "TELEFONISTA" },
    { "abr": "LIM", "rol": "LIMPIEZA" },
    { "abr": "SUP", "rol": "SUPERVISOR" },
    { "abr": "GUA", "rol": "GUARDIA" }
]
function DetalleReporteSucursal(props) {
    const { info,turno } = props;
    const [infoSucursal, setInfoSucursal] = useState(-1)
    const [requeridos, setRequeridos] = useState([]);
    const [asignados, setAsignados] = useState([]);
    const [activos, setActivos] = useState([]);
    const [actualizar, setActualizar] = useState(false);
    const [infoRecuparado, setInfoRecuperado] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [listaEmpleados,setListaEmpleados] = useState([]);
    const getActivos = (rol) => {
        var dato = mapeo.filter((dat) => dat.abr === rol)
        var cont = 0;
        for (var f = 0; f < activos.length; f++) {
            var aux = dato.find((item) => item.id == activos[f].EMPRESA_CARGO);
            if (aux != undefined) {
                cont += 1
            }
        }
        return cont
    }
    var getAsignados = (rol) => {
        var dato = mapeo.filter((dat) => dat.abr === rol)
        var cont = 0;
        for (var f = 0; f < asignados.length; f++) {
            var aux = dato.find((item) => item.id == asignados[f].EMPRESA_CARGO);
            if (aux != undefined) {
                cont += 1
            }
        }
        return cont
    }
    var getRequeridos = (rol) => {
        var aux = requeridos.filter((item) => item.ROL === rol && (turno=='*'||item.TURNO === turno));
        if (aux.length !== 0) {
            return aux[0].CANTIDAD;
        } else {
            return 0
        }
    }
    function verDetalles(dato) {
        console.log(dato)
        var cargos = mapeo.filter((dat) => dat.abr === dato.abr)
        var listaAux= []
        for (var crg of cargos){
            var datt = asignados.filter((item)=>item.EMPRESA_CARGO==crg.id);
            listaAux.push(...datt)
        }
        if(listaAux.length!=0){
            setListaEmpleados(listaAux);
            setModalShow(true);
        }else{
            MsgUtils.msgAdvertencia("no existe personas en este cargo")
        }
    }
    useEffect(() => {
        if (infoSucursal !== -1) {
            var regional = JSON.parse(localStorage.getItem("__react_session__")).regional;
            fetch(`${server}/reporte/getPersonalSoloSucursal`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional: regional,
                    sucursal: info.ID_SUCURSAL
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        setInfoRecuperado(data.ok)
                        setRequeridos(data.ok.REQUERIDO);
                        setAsignados(data.ok.ASIGNADO);
                        setActivos(data.ok.ASIGNADO.filter((item) => item.ASISTENCIA.length != 0));
                    }
                    //setLoading(false);
                })
                .catch(err => console.log(err));
        }
    }, [actualizar])
    useEffect(() => {
        if (infoSucursal == -1) {
            setInfoRecuperado(info);
            setInfoSucursal(info.ID_SUCURSAL);
            setRequeridos(info.REQUERIDO);
            setAsignados(info.ASIGNADO);
            if(turno!='*'){
                setActivos(info.ASIGNADO.filter((item) => item.ASISTENCIA.length != 0 && item.EMPRESA_TURNO==turno));
            }else{
                setActivos(info.ASIGNADO.filter((item) => item.ASISTENCIA.length != 0 ));
            }
        }
    }, [])
    return (
        <div>
            {infoSucursal !== -1 && <CardSucursal info={infoRecuparado} tipo={'A'} turno={turno}/>}
            {activos !== undefined &&
                <div className='table-responsive'>
                    <table className="table table-dark table-striped table-hover">
                        <thead>
                            <tr className='bg-gradient text-center'>
                                <th scope="col">Cargo</th>
                                <th scope="col">Req.</th>
                                <th scope="col">Asig.</th>
                                <th scope="col" className='colorVerde'>Activo</th>
                                <th scope='col'></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rolesUnicos.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <th scope="row" className='col-2'>{mapeo.find((data) => data.abr == item.abr).rol}</th>
                                        <td className='col-1 text-center'>{getRequeridos(item.abr)}</td>
                                        <td className='col-1 text-center fw-bold'>
                                            {getAsignados(item.abr)}
                                        </td>
                                        <td className='col-1 text-center colorVerde'>
                                            {getActivos(item.abr)}
                                        </td>
                                        <td className='text-end'>
                                            <button className='btn btn-sm btn-secondary'
                                                title='Ver detalles de los colaboradores que estan con este cargo'
                                                onClick={() => verDetalles(item)}>
                                                <i className="fa-solid fa-timeline fa-xl"></i> Detalle
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>}
            <div className='btn-group btn-group-sm m-0 p-0 w-100'>
                <button className='btn btn-sm btn-secondary bg-gradient mx-1' onClick={() => setActualizar(!actualizar)}>
                    <i className="fa-solid fa-arrows-rotate fa-xl"></i> Actualizar
                </button>
                <button className='btn btn-sm btn-secondary bg-gradient mx-1'>
                    <i className="fa-solid fa-teeth-open fa-xl"></i> Historial
                </button>
            </div>
            <Modal show={modalShow} onHide={() => setModalShow(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>
                        <div className='text-light'>Detalles</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    <div className='container-fluid text-start py-4 overflow-auto' style={{maxHeight:'400px'}}>
                        <ul className="list-group list-group-sm">
                            {listaEmpleados.map((item,index)=>{
                                return(<li className="list-group-item mb-1 lh-1" key={index}>
                                    <div className={`${item.ASISTENCIA.length!=0?'text-success fw-bold':''}`}>
                                        <div>Nombre: {item.NOMBREX}</div>
                                        <div>Turno: {item.TURNO}</div>
                                    </div>
                                </li>)
                            })}
                        </ul>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default DetalleReporteSucursal
